import React, { useContext } from 'react'
import { Col, Row } from 'antd'
import IntervenerCard from './IntervenerCard'
import GlobalContext from '../GlobalContext'

const Cards = ({ interveners }) => {
  const { screens } = useContext(GlobalContext)
  const span = screens.xs ? 24 : 6
  const result = []
  interveners.forEach((intervener) => {
    result.push(
    <Col span={span} key={intervener.id}>
      <IntervenerCard intervener={intervener} />
      </Col>
    )
  })
  return result
}

export default function IntervenerCards ({ interveners }) {
  const pad = { xs: 8, sm: 16, md: 24, lg: 32 }

  return (
    <Row gutter={[pad, pad]} justify="center">
      <Cards interveners={interveners} />
    </Row>
  )
}
